// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2mo5X","error":"Textarea_error__26RbA","readonly":"Textarea_readonly__1uAuq","disabled":"Textarea_disabled__28dD7"};